import ILDefaultAva from 'assets/icons/default-ava-profile-user.svg'
import Flatpickr from 'react-flatpickr'
import { useDispatch, useSelector } from 'react-redux'
import {
  Badge,
  Card,
  CardBody,
  CardText,
  Col,
  FormGroup,
  Label,
  Row,
} from 'reactstrap'

// Form
import {
  setIsModalOpenAddAddressBook,
  setSearchAddressBook,
} from 'features/private-views/address-book/addressBookSlice'
import InputAddressBook from 'features/private-views/address-book/InputAddressBook'
import ModalAddContact from 'features/private-views/address-book/ModalAddContact'
import { Indonesian } from 'flatpickr/dist/l10n/id'
import { useEffect, useRef, useState } from 'react'
import { AlertCircle, Calendar } from 'react-feather'
import { useLocation } from 'react-router-dom'
import { emailCheck } from 'utils/emailCheck'
import ModalUnregis from '../ModalUnregis'
import { checkSellerInfo } from '../sellCommodityAction'
import {
  setInitialBuyer,
  setTrxDate,
  toggleAllowPayment,
  toggleAllowPaymentByValue,
  toggleModalUnregis,
} from '../sellCommoditySlice'
import { P } from 'components'
import ProfilePic from 'components/PMBProfilePic'

const defaultPayments = [
  { name: 'Uang Belanja', alwaysOn: true },
  { name: 'Talangin', alwaysOn: true },
]

const InfoSeller = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const isManual = location.state?.isManual
  const [dataSeller, setDataSeller] = useState('')
  const [savedContacts, setSavedContacts] = useState([])
  const addressBookRef = useRef(null)

  const { isModalOpenAddAddressBook, searchAddressBook } = useSelector(
    (e) => e.addressBook,
  )
  const { profile } = useSelector((s) => s.dashboard)
  const { orders } = useSelector((state) => state.sellCommodity)
  const { buyer } = orders

  const [errorMessage, setErrorMessage] = useState('')
  const [selectedContact, setSelectedContact] = useState(null)
  const allowPayment = useSelector(
    (s) => s.sellCommodity.orders.buyer?.allowPayment || {},
  )

  const handleSubmit = (val) => {
    if (val) {
      setErrorMessage('')
      dispatch(
        checkSellerInfo({
          search: encodeURIComponent(val),
          type: 'SELL',
          payment: 'OPTION',
        }),
      ).then((e) => {
        const payload = e?.payload
        if (e?.payload?.profileStatus === 'UNREGISTERED') {
          dispatch(toggleModalUnregis())
        }
        const { error } = e
        if (error?.message == 'Rejected') {
          setErrorMessage(e?.payload)
          if (isManual && selectedContact) {
            dispatch(
              setInitialBuyer({
                fullName: selectedContact?.relationName,
                phoneNumber: selectedContact?.relationPhoneNumber,
                email: selectedContact?.relationEmail,
                profileStatus: 'UNVERIFIED',
                userId: selectedContact?.id,
                allowPayment: {
                  cash: 1,
                  payable: 0,
                  cod: 0,
                },
              }),
            )
          }
        }

        const allow = payload?.allowPayment
        const sellerId = profile?.userId
        const buyerId = payload?.userId

        if (!allow || !sellerId || !buyerId) return

        const history = JSON.parse(
          localStorage.getItem('allowPaymentHistory') || '[]',
        )
        const existing = history.find(
          (item) => item.sellerId === sellerId && item.buyerId === buyerId,
        )

        if (!existing) return
        if (allow.cash === 1) {
          dispatch(
            toggleAllowPaymentByValue({ key: 'cash', value: existing.cash }),
          )
        }

        if (allow.payable === 1) {
          dispatch(
            toggleAllowPaymentByValue({
              key: 'payable',
              value: existing.payable,
            }),
          )
        }
      })
    }
  }

  let isEmail = emailCheck(buyer?.fullName)

  useEffect(() => {
    if (profile?.userId) {
      const saved = JSON.parse(
        localStorage.getItem(`savedContacts-${profile?.userId}`),
      )
      setSavedContacts(saved ?? [])
    }
  }, [profile])

  const toggleOpenCloseAddContact = () => {
    dispatch(setIsModalOpenAddAddressBook(!isModalOpenAddAddressBook))
  }

  const handleSelectedContact = (contact) => {
    setDataSeller(contact?.relationPhoneNumber ?? contact?.relationEmail ?? '')
    setSelectedContact(contact)
  }

  useEffect(() => {
    if (
      selectedContact?.relationPhoneNumber ||
      selectedContact?.relationEmail
    ) {
      handleSubmit(
        selectedContact?.relationPhoneNumber || selectedContact?.relationEmail,
      )
      dispatch(setInitialBuyer(null))
    } else {
      setDataSeller('')
      setErrorMessage('')
      dispatch(setInitialBuyer(null))
    }
  }, [selectedContact])

  // HANDLE AUTO FOCUS
  useEffect(() => {
    setTimeout(() => {
      addressBookRef.current?.focus()
    }, 0)
  }, [])

  return (
    <>
      <ModalUnregis
        data={dataSeller}
        setSelectedContact={setSelectedContact}
        selectedContact={selectedContact}
      />
      <ModalAddContact
        isOpen={isModalOpenAddAddressBook}
        toggle={toggleOpenCloseAddContact}
        isOutsideAddressBook
      />
      <Card className="border-0 shadow-sm">
        <CardBody className="p-4">
          <Row>
            <Col sm="12">
              <h5 className="text-md">Penjualan</h5>
              <FormGroup className="mt-4">
                <Label>Tanggal Transaksi</Label>
                <div className="d-flex align-items-center justify-content-center border rounded">
                  <Calendar size={17} className="ms-3" />
                  <Flatpickr
                    options={{
                      locale: Indonesian,
                      dateFormat: 'd-M-Y',
                      defaultDate: new Date(),
                      maxDate: new Date(),
                      onClose: (selectedDate, dateStr, instance) => {
                        dispatch(setTrxDate(selectedDate[0]))
                      },
                    }}
                    className="form-control flat-picker bg-transparent border-0 shadow-none"
                  />
                </div>
              </FormGroup>

              <div className="mb-4" data-testid="sell-form-buyer-search">
                <InputAddressBook
                  title="Pembeli"
                  onSelectContact={handleSelectedContact}
                  fieldName="relationName"
                  editValue={
                    selectedContact?.relationPhoneNumber
                      ? `${selectedContact?.relationName} (${selectedContact?.relationPhoneNumber})`
                      : selectedContact?.relationEmail
                        ? `${selectedContact?.relationName} (${selectedContact?.relationEmail})`
                        : selectedContact?.relationName
                  }
                  onClickAdd={(localSearch) =>
                    dispatch(setSearchAddressBook(localSearch))
                  }
                  innerRef={addressBookRef}
                  isRecentTrx
                  isCloseSelection={orders?.buyer ? true : false}
                  valueName={orders?.buyer ? orders?.buyer?.fullName : ''}
                />
              </div>
            </Col>
            {errorMessage && !isManual && (
              <FormGroup>
                <small className="text-danger">
                  <AlertCircle size={15} /> {errorMessage}
                </small>
              </FormGroup>
            )}
            <Col sm="12">
              {buyer ? (
                <CardBody className="p-0">
                  <P className="mb-2">Informasi pembeli</P>
                  <Card style={{ minHeight: 68 }}>
                    <CardBody>
                      <div className="flex-centered justify-content-between">
                        <div className="flex-centered gap-2">
                          <ProfilePic
                            imgSrc={
                              buyer?.partnership?.logo ?? buyer.profileImg
                            }
                            altText={
                              buyer?.partnership?.name ?? buyer?.fullName
                            }
                            name={buyer?.partnership?.name ?? buyer?.fullName}
                            avatarSeed={buyer?.userId}
                            width={36}
                            height={35}
                          />
                          <div className="d-flex flex-column">
                            <span className="text-sm fw-semibold">
                              {buyer?.partnership?.name ?? buyer?.fullName}
                            </span>
                            {buyer?.otherPicUser?.fullName && (
                              <span
                                className="text-muted"
                                style={{ fontSize: 12 }}
                              >
                                PIC: {buyer?.otherPicUser?.fullName}
                              </span>
                            )}
                          </div>
                        </div>
                        {isEmail ? (
                          <></>
                        ) : (
                          <Badge
                            size="sm"
                            disabled
                            className={
                              (buyer?.profileStatus ?? '')
                                .toString()
                                .toLowerCase() === 'verified'
                                ? 'badge-verify'
                                : 'badge-warning'
                            }
                          >
                            {buyer?.profileStatus}
                          </Badge>
                        )}
                      </div>
                    </CardBody>
                  </Card>
                </CardBody>
              ) : (
                <></>
              )}
            </Col>
            {!isManual && (
              <Col sm="12" className="mt-3">
                <CardBody className="p-0">
                  <P className="mb-1 fw-bold">Pilih Metode Pembayaran</P>

                  <div>
                    {defaultPayments.map((p) => (
                      <label
                        key={p.name}
                        className="d-flex align-items-center gap-2 py-2 px-3 border rounded bg-light mt-2"
                      >
                        <input type="checkbox" checked disabled />
                        <P className="mb-0">{p.name}</P>
                      </label>
                    ))}
                  </div>

                  {Object.entries(allowPayment).map(([key, value]) => (
                    <label
                      key={key}
                      className="d-flex align-items-center gap-2 py-2 px-3 border rounded hover:border-primary transition mt-2"
                    >
                      <input
                        type="checkbox"
                        checked={value === 1}
                        onChange={() => dispatch(toggleAllowPayment(key))}
                        style={{ accentColor: '#006386' }}
                      />
                      <P className="mb-0">
                        {key === 'cash'
                          ? 'Tunai'
                          : key === 'payable'
                            ? 'Kredit Penjual'
                            : key === 'cod'
                              ? 'COD'
                              : key}
                      </P>
                    </label>
                  ))}
                </CardBody>
              </Col>
            )}
          </Row>
        </CardBody>
      </Card>
    </>
  )
}

export default InfoSeller
